
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';
    import VWidget from '@/components/VWidget.vue';
    import FormBase from '@/components/helper/form-base.vue';
    
    @Component({
        components: { VWidget, FormBase }
    })
    export default class CompanyForm extends ListBase {
        entity: string = 'company';
        modalShow: boolean = true;

        get company() {
            return this.$store.state.session.company;
        }

        get loading() {
            return this.$store.state.company.loading;
        }
        
        async save() {
            await this.$store.dispatch({
                type: 'company/update',
                data: this.company
            });
            Util.abp.notify.success(this, 'Guardado Correctamente');

            //this.$store.commit('session/setCompany', this.$store.state.company.editModel);
        }
        
        items = [
            this.gItem({ type: 'text', prop: 'document', label: 'Ruc', required: true, size: 4 }),
            this.gItem({ type: 'spacer', size: 6 }),
            this.gItem({ type: 'active', size: 2 }),
            this.gItem({ type: 'text', prop: 'name', label: 'Razon Social', required: true, size: 6 }),
            this.gItem({ type: 'text', prop: 'name_legal', label: 'Razon Comercial', size: 6 }),
            this.gItem({ type: 'email', prop: 'email', label: 'Email', size: 6 }),
            this.gItem({ type: 'website', prop: 'website', label: 'Website', size: 6 }),
            this.gItem({ type: 'textarea', prop: 'note', label: 'Notas' }),
        ]
        
        mounted() {
            this.modalShow = true;
        }

        async created() {
            
            
        }
    }